/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_TitleInputs */

const en_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Your Resume`)
};

const de_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hinzufügen`)
};

const fr_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter ton CV`)
};

const es_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar su currículum`)
};

const it_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il Tuo Curriculum`)
};

const nl_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg je CV toe`)
};

const pl_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj swoje CV`)
};

const fi_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää Ansioluettelosi`)
};

const da_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj dit CV`)
};

const sv_onboarding_resume_title = /** @type {(inputs: Onboarding_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till ditt CV`)
};

/**
* | output |
* | --- |
* | "Add Your Resume" |
*
* @param {Onboarding_Resume_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_title = /** @type {((inputs?: Onboarding_Resume_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_title(inputs)
	if (locale === "fr") return fr_onboarding_resume_title(inputs)
	if (locale === "es") return es_onboarding_resume_title(inputs)
	if (locale === "it") return it_onboarding_resume_title(inputs)
	if (locale === "nl") return nl_onboarding_resume_title(inputs)
	if (locale === "pl") return pl_onboarding_resume_title(inputs)
	if (locale === "fi") return fi_onboarding_resume_title(inputs)
	if (locale === "da") return da_onboarding_resume_title(inputs)
	if (locale === "sv") return sv_onboarding_resume_title(inputs)
	return en_onboarding_resume_title(inputs)
});